export enum NavigationButtonEnum {
	BACK = 'back',
	FORWARD = 'forward',
	EXTERNAL = 'external',
	NONE = 'none',
}
